
import Vue from "vue";
import AppModelColumnSelect from "@/components/models/ColumnSelect.vue";
import AppBrowseColumnSelectJsonProperty from "@/components/models/BrowseColumnSelectJsonProperty.vue";
import { Browse } from "@/models/browse";
import { ViewColumn } from "@/utils/views/view-column";
import { ModelNamedProperty } from "@/utils/models/named-property";

export default Vue.extend({
	data(){
		return {
			selectedProp: null as ModelNamedProperty | null,
			decimals: this.field.Decimals as null | number,
			booleanMode: (this.field.TextTrue || this.field.TextFalse ? "text" : null) as null | "text",
			textTrue: this.field.TextTrue || this.$t("common.yes").toString(),
			textFalse: this.field.TextFalse || this.$t("common.no").toString()
		};
	},
	props: {
		field: {
			type: Object as () => ViewColumn,
			required: true
		},
		browse: {
			type: Object as () => Browse,
			required: true
		},
		add: Boolean
	},
	computed: {
		selectedPropName: {
			get():string {
				if (!this.selectedProp) return "";
				return this.selectedProp.path;
			},
			set(val:string) {
				let found = this.browse.type.getBrowseFields().find(f=>f.path == val) || null;
				if (found != this.selectedProp) {
					this.decimals = null;
				}
				this.selectedProp = found;
			}
		},
		isDecimalSettingAllowed():boolean {
			if (!this.selectedProp) return false;
			return this.selectedProp.field.type == "number";
		},
		isBoolean():boolean {
			if (!this.selectedProp) return false;
			return this.selectedProp.field.type == "boolean";
		},
		isJson():boolean {
			if (!this.selectedProp) return false;
			return this.selectedProp.field.type == "json";
		}
	},
	watch: {
		selectedProp(){
			if (!this.isJson) {
				this.field.JsonProperty = "";
			}
		}
	},
	methods: {
		onPropName(name:string){
			this.field.Name = name.replace(/<([^>]+?)([^>]*?)>(.*?)<\/\1> /ig, "");
		},
		toggleDecimals(useDefault:boolean){
			this.decimals = useDefault ? null : 2;
		},
		save(){
			if (!this.selectedProp) {
				this.$wf.notify(this.$ct("error-no-column-selected").toString(), "danger", 3000, "exclamation-triangle");
				return;
			}
			this.field.Property = this.selectedProp.path;
			this.field.IsComputed = this.selectedProp.field.isComputed;
			let pathParts = this.field.Property.split(".");
			pathParts.pop();
			let pathPrefix = pathParts.join(".");
			this.field.ComputedPreloads = [];
			if (this.field.IsComputed) {
				this.field.ComputedPreloads = (this.selectedProp.field.dependencies || []).map(d=>pathPrefix ? `${pathPrefix}.${d}` : d);
			}
			if (this.field.Name.trim() == "") {
				this.field.Name = this.selectedProp.getPropertyTranslation();
			}
			this.field.Decimals = this.isDecimalSettingAllowed ? this.decimals : null;
			this.field.TextTrue = "";
			this.field.TextFalse = "";
			if (this.isBoolean && this.booleanMode == "text") {
				this.field.TextTrue = this.textTrue;
				this.field.TextFalse = this.textFalse;
			}
			this.$emit("save");
		}
	},
	mounted(){
		if (this.field.Property) {
			this.selectedProp = this.browse.type.getBrowseFields().find(f=>f.path == this.field.Property) || null;
			this.decimals = this.field.Decimals;
		}
	},
	components: {
		AppModelColumnSelect,
		AppBrowseColumnSelectJsonProperty
	},
	i18nEx: {
		componentPrefix: "components.view-editor"
	}
});
